export default __webpack_public_path__ + "images/d1c28d28820d524d95ad52456ea01a34-promoted-preview-background.svg";